// Generated by purs version 0.13.8
"use strict";
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Lunarbox_Component_Tooltip = require("../Lunarbox.Component.Tooltip/index.js");
var Lunarbox_Component_Utils = require("../Lunarbox.Component.Utils/index.js");
var iconWithTooltip = function (tooltipText) {
    return function (position) {
        return function (name) {
            return Lunarbox_Component_Tooltip.tooltip(tooltipText)(position)(Halogen_HTML_Elements.i)([ Lunarbox_Component_Utils.className("material-icons") ])([ Halogen_HTML_Core.text(name) ]);
        };
    };
};
var icon = function (name) {
    return Halogen_HTML_Elements.i([ Lunarbox_Component_Utils.className("material-icons") ])([ Halogen_HTML_Core.text(name) ]);
};
module.exports = {
    icon: icon,
    iconWithTooltip: iconWithTooltip
};
